"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSummaryItem = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const Title = (0, styled_components_1.default)(base_react_components_1.Copy).attrs(() => ({ light: true })).withConfig({ displayName: "reports-Title", componentId: "reports-g65k3m" }) ``;
const ForwardIcon = (0, styled_components_1.default)(base_react_components_1.Icon).attrs(() => ({ name: 'actions/arrow-forward' })).withConfig({ displayName: "reports-ForwardIcon", componentId: "reports-1bi0q4s" }) ``;
const Content = styled_components_1.default.div.withConfig({ displayName: "reports-Content", componentId: "reports-k13qqs" }) ``;
const ComponentTypeManager = (0, styled_components_1.default)(base_react_components_1.Link).attrs(({ href }) => (href ? {} : { as: 'section' })).withConfig({ displayName: "reports-ComponentTypeManager", componentId: "reports-1oiw77m" }) `
  align-items: center;
  display: grid;
  grid:
    'indicator title   next'
    'indicator content next'
    / minmax(4px, min-content) 1fr min-content;
  gap: 8px 16px;

  & > ${Title} {
    grid-area: title;
  }

  & > * {
    grid-area: content;
  }

  & > ${base_react_components_1.Icon} {
    grid-area: indicator;
  }

  & > ${ForwardIcon} {
    grid-area: next;
  }

  &::before {
    align-self: stretch;
    background-color: ${({ status }) => (status && status in base_react_components_1.theme ? base_react_components_1.theme[status] : 'transparent')};
    border-radius: 4px;
    ${({ icon }) => (icon ? '' : `content: ''`)};
    grid-area: indicator;
  }
`;
/**
 * The ReportSummaryItem component summarizes a part of a report. It may also link to details within the report
 *
 * `ReportSummaryItem` will forward all props on to the underlying `Link` component so props like `target` are also
 * supported and work the same as they would in a BRC `Link` component.
 */
const ReportSummaryItem = (_a) => {
    var { href, icon, title = '', status, children } = _a, linkProps = __rest(_a, ["href", "icon", "title", "status", "children"]);
    return (react_1.default.createElement(ComponentTypeManager, Object.assign({ href: href, status: status, icon: icon }, linkProps, { "data-testid": "ReportSummaryItem:Link" }),
        !!icon && react_1.default.createElement(base_react_components_1.Icon, { role: "img", "aria-label": icon, name: icon }),
        react_1.default.createElement(Title, null, title),
        react_1.default.createElement(Content, null, children),
        !!href && react_1.default.createElement(ForwardIcon, { "data-testid": "ReportSummaryItem:Link-Arrow" })));
};
exports.ReportSummaryItem = ReportSummaryItem;
exports.default = (0, styled_components_1.default)(exports.ReportSummaryItem).withConfig({ componentId: "reports-12hu47f" }) ``;
//# sourceMappingURL=index.js.map